// extracted by mini-css-extract-plugin
export default {"cameras-wrapper":"CamerasPage_cameras-wrapper__wUXMC","text":"CamerasPage_text__IjunN","camera":"CamerasPage_camera__wB7KS"};